import React, { useState } from 'react';
import SourceCode from './SourceCode';
import { Button, Tabs, type TabsProps } from 'antd';
import Preview from './Preview';
import { LaptopOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import HtmlToPdf from '../../molecules/HtmlToPdf/HtmlToPdf';


function HtmlEditor({ html, setHtml, trigger, selectedRecord, updateTemplatData }) {

  const [tabKey, setTabKey] = useState("0");
  const [loading, setLoading] = useState(false);
  const onChange = (key: string) => {
    setTabKey(key);
  };

  const saveTemplateChanges = async () => {

    try {
      setLoading(true);
      const result = trigger == 0 ?
        await updateTemplatData(selectedRecord, null) :
        await updateTemplatData(selectedRecord, 1);
      if (result?.status) {
        setLoading(false);
      }
    } catch (error) {
      console.log(error)
      setLoading(false);
    }
  }

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <>
          <LeftOutlined /><RightOutlined />Source
        </>
      ),
      children: <SourceCode placeHolders={selectedRecord?.placeholders} trigger={trigger} html={html} setHtml={setHtml} />,
    },
    {
      key: '2',
      label: (
        <>
          <LaptopOutlined />Preview
        </>
      ),
      children: <Preview  html={html}/>,

    },
  ];
  return (
    <React.Fragment key={selectedRecord?.templateId}>
      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />

      {
        tabKey === '2' &&
        (
          <>
            <div style={{ position: 'absolute', top: '90px', right: '9px' }}>
              <Button
                size="large"
                type="primary"
                onClick={() => saveTemplateChanges()}
                className="property_card_btn"
                disabled={loading}
              >
                {'Save'}
              </Button>
            </div>

            <div style={{ position: 'absolute', top: '67px', right: '0px' }}>
              <HtmlToPdf loading={loading} setLoading={setLoading} elementId="pdf-content" fileName={selectedRecord?.templateName} />
            </div>
          </>
        )
      }

    </React.Fragment>

  );
}

export default React.memo(HtmlEditor);
